import React from 'react';
import PropTypes from 'prop-types';
import { gql } from '@common/hooks';
import StateArea from './state-area/state-area';
import { ApplicationNurseProfileHeader } from '@applicant-flow/components';

export function ApplicationHeader({ application }) {
  const worksProfile = application.worksProfile;
  const supplier = application.supplier;
  const submissionTime = application.createdAt;
  const { activeOffer } = application;

  return (
    <ApplicationNurseProfileHeader
      supplier={supplier}
      worksProfile={worksProfile}
      submissionTime={submissionTime}
      application={application}
    >
      <StateArea
        application={application}
        offer={activeOffer}
        staffingRequest={application.staffingRequest}
      />
    </ApplicationNurseProfileHeader>
  );
}

ApplicationHeader.fragments = {
  worksProfile: gql`
    fragment ApplicationHeaderWorksProfileFragment on WorksProfile {
      id
      ...NurseProfileHeaderWorksProfileFragment
    }
    ${ApplicationNurseProfileHeader.fragments.worksProfile}
  `,
};

ApplicationHeader.propTypes = {
  application: PropTypes.object,
};
